import ElementsTable from '../../../elementsTable';
import './styles.css';

export default function InstructorClassifyingNormalModal({
  onCloseButtonClick,
  elementsData,
  elementsHeaders,
  allOtherAccountsData,
  allOtherAccountsHeaders,
  elementsOtherAccountsNormalData,
  elementsOtherAccountsNormalHeaders
}) {
  const isClassificationPartVisible = (elementsData && elementsData.length > 0) || (allOtherAccountsData && allOtherAccountsData.length > 0);
  const isNormalPartVisible = elementsOtherAccountsNormalData && elementsOtherAccountsNormalData.length > 0;
  
  return (
    <div className="modal-overlay" onClick={onCloseButtonClick}>
      <div className="modal instructor-decision-insights-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onCloseButtonClick}></button>
        <div className="instructor-decision-insights-modal-content">
          {
            isClassificationPartVisible && 
              <>
                <div className="decision-insights-content-part">
                  <h2>Classification</h2>
                  {
                    elementsData && elementsData.length > 0 &&
                      <ElementsTable 
                        title="Elements"
                        tableColumnHeader="Sorting Items"
                        tableHeaders={elementsHeaders}
                        tableData={elementsData}
                      />        
                  }
                  {
                    allOtherAccountsData && allOtherAccountsData.length > 0 &&
                      <ElementsTable 
                        title="All other Accounts"
                        tableColumnHeader="Sorting Items"
                        tableHeaders={allOtherAccountsHeaders}
                        tableData={allOtherAccountsData}
                      />        
                  }
                </div>
                {
                  isNormalPartVisible &&
                    <div className="instructor-decision-insights-divider"></div>
                }
              </>
          }
          {
            isNormalPartVisible &&
              <div className="decision-insights-content-part">
                <h2>Normal Balance</h2>
                <ElementsTable 
                  title="Elements & Other Accounts"
                  tableColumnHeader="Sorting Items"
                  tableHeaders={elementsOtherAccountsNormalHeaders}
                  tableData={elementsOtherAccountsNormalData}
                />
              </div>
          }
        </div>
      </div>
    </div>
  );
}
